import { ActionIcon, Group, Loader, useMantineTheme } from '@mantine/core';
import { IconCalendarEvent, IconFilter, IconMessageCircle, IconRefresh, IconSend, IconTrash } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { i18n } from '@lingui/core';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import { MessageContext } from '../../../Service/Context/MessageContextV2';
import { EmailBoxContext } from '../../../Service/Context/EmailBoxContext';
import { MessageS } from '../../../Service/MessageS';
import { openDeleteEmailsModal } from '../../../Organismns/Message/MessageModals';
import ActionIconWithText from './ActionIconWithText';

interface HandlersProps {
  filter: () => void;
}

const InboxPageFooter: FC<HandlersProps> = ({ filter }) => {
  const { openWidget } = useConversationsWidget();
  const navigate = useNavigate();
  const { box } = useParams();
  const { refresh, selectedMessage, messages, loading, isBookitupScope, pageNumber, setPageNumber } =
    useContext(EmailBoxContext);
  const { initMessage } = useContext(MessageContext);
  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  const deleteHandler = async () => {
    if (selectedMessage) {
      if (box === 'trash') {
        const deleted = await MessageS.deleteEmail(selectedMessage.id);
        if (deleted) {
          refresh();
        }
      } else {
        const email = await MessageS.patchEmail(selectedMessage.id, { trash: true });
        if (email) {
          refresh();
        }
      }
    } else {
      removeEmailsHandler();
    }
  };

  const removeEmailsHandler = () =>
    openDeleteEmailsModal({
      ids: messages.map((m) => m.id),
      onDelete: () => {
        if (pageNumber === 0) {
          refresh();
        } else {
          setPageNumber(0);
        }
      },
    });

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText label="Filter" onClick={filter} useDefaultWidth>
        <IconFilter />
      </ActionIconWithText>
      {!loading && (
        <ActionIconWithText label="Auffrischen" useDefaultWidth onClick={refresh}>
          <IconRefresh />
        </ActionIconWithText>
      )}
      {loading && <Loader size="md" variant="dots" />}
      <>
        <ActionIcon
          onClick={() => initMessage()}
          size="xl"
          radius="xl"
          variant="gradient"
          gradient={
            darkMode
              ? { from: colors.blue[1], to: colors.blue[4], deg: 135 }
              : { from: colors.blue[4], to: colors.blue[0], deg: 135 }
          }
        >
          <IconSend color="#E5E5E5" />
        </ActionIcon>
        {isBookitupScope && messages.length > 0 && (
          <ActionIconWithText label={i18n._('actions.delete')} useDefaultWidth onClick={deleteHandler}>
            <IconTrash />
          </ActionIconWithText>
        )}
        {isBookitupScope && messages.length === 0 && (
          <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
            <IconCalendarEvent />
          </ActionIconWithText>
        )}
        {!isBookitupScope && (
          <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
            <IconCalendarEvent />
          </ActionIconWithText>
        )}
        <ActionIconWithText label="Support" onClick={openWidget} useDefaultWidth>
          <IconMessageCircle />
        </ActionIconWithText>
      </>
    </Group>
  );
};

export default InboxPageFooter;
